<template>
<div>
  <div class="card"
    v-show="currentCardId == 'profile'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>プロフィールを入力</h2>
        <p>氏名記入欄や年号の計算に使います</p>
      </div>
      <div class="card-content">
        <div class="edit-form">
          <div v-if="needs('name')"
            class="edit-form-item">
            <div class="item-name">氏名</div>
            <div class="item-body flex">
              <el-input v-model="formatData.lastName"
                class="input-sm"
                placeholder=""
                title="姓"
                @keyup.native.enter="$formLib.nextInput($refs.firstName)"></el-input>
              <el-input v-model="formatData.firstName"
                  ref="firstName"
                class="input-sm"
                placeholder=""
                title="名"
                @keyup.native.enter="$formLib.nextInput($refs.lastNameFurigana)"></el-input>
            </div>
          </div>
          <div v-if="needs('email')"
            class="edit-form-item">
            <div class="item-name">連絡先（Email）</div>
            <div class="item-body">
              <el-input class="input-md"
                placeholder=""
                title="メールアドレス"
                ref="email"
                v-model="formatData.email"
                type="email"></el-input>
              <div v-if="$firebase.isAuthenticated && $firebase.user.email !== formatData.email">
                <el-button @click="setAccountEmail"
                  type="text">「{{ $firebase.user.email }}」を入力する</el-button>
              </div>
            </div>
          </div>
          <div v-if="needs('furigana')"
            class="edit-form-item">
            <div class="item-name">ふりがな</div>
            <div class="item-body flex">
              <el-input ref="lastNameFurigana"
                v-model="formatData.lastNameFurigana"
                class="input-sm"
                placeholder=""
                title="せい"
                @keyup.native.enter="$formLib.nextInput($refs.firstNameFurigana)"
                @blur="formatData.lastNameFurigana = $formLib.katakana2Hiragana(formatData.lastNameFurigana)"></el-input>
              <el-input ref="firstNameFurigana"
                v-model="formatData.firstNameFurigana"
                class="input-sm"
                placeholder=""
                title="めい"
                @keyup.native.enter="$formLib.nextInput($refs.birthYear)"
                @blur="formatData.firstNameFurigana = $formLib.katakana2Hiragana(formatData.firstNameFurigana)"></el-input>
            </div>
          </div>
          <div v-if="needs('birth')"
            class="edit-form-item">
            <div class="item-name">生年月日</div>
            <div class="item-body flex align-items-center">
              <el-input class="input-xs input-4-digit"
                placeholder="2000"
                title="誕生年"
                v-model="formatData.birthYear"
                min="1890"
                ref="birthYear"
                @keyup.native.enter="$formLib.nextInput($refs.birthMonth)"
                :max="new Date().getFullYear()"
                type="number"></el-input><span>年</span>
              <el-input class="input-xs input-2-digit"
                placeholder="12"
                title="誕生月"
                ref="birthMonth"
                @keyup.native.enter="$formLib.nextInput($refs.birthDay)"
                v-model="formatData.birthMonth"
                min="1"
                max="12"
                type="number"></el-input><span>月</span>
              <el-input class="input-xs input-2-digit"
                placeholder="31"
                title="誕生日"
                ref="birthDay"
                v-model="formatData.birthDay"
                min="1"
                :max="calcLastDay"
                type="number"></el-input><span>日</span>
            </div>
          </div>
          <div v-if="needs('birth')"
            class="edit-form-item">
            <div class="item-name">年齢</div>
            <div class="item-body flex align-items-center">
              <el-input class="input-xs input-4-digit"
                placeholder=""
                title="年齢"
                ref="age"
                v-model="formatData.age"
                min="1"
                max="150"
                type="number"></el-input><span>歳</span>
            </div>
          </div>
          <div v-if="needs('sex')"
            class="edit-form-item">
            <div class="item-name">性別</div>
            <!--
            ISO 5218
            https://qiita.com/aoshirobo/items/32deb45cb8c8b87d65a4
            -->
            <div class="item-body">
              <div class="radio-horizontal">
                <el-radio v-model="formatData.sex"
                  label="1">男性</el-radio>
                <el-radio v-model="formatData.sex"
                  label="2">女性</el-radio>
                <el-radio v-model="formatData.sex"
                  label="0">記入しない</el-radio>
                <el-radio v-model="formatData.sex"
                  label="-1">表示しない</el-radio>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card"
    v-show="currentCardId == 'address'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>住所を入力</h2>
        <p>建物名や部屋番号は略さず入力しましょう。<br>ただし、ふりがなは番地などの数字は入力不要なので、都道府県・市区町村までが入力されていればOKです。</p>
      </div>
      <div class="card-content">
        <div class="edit-form">
          <div v-if="needs('address')"
            class="edit-form-item">
            <div class="item-name">
              郵便番号
              <small v-if="$deviceLib.isOnline">(ハイフン不要・住所が自動入力されます)</small>
              <small v-else>(※オフラインのため住所の自動入力がご利用いただけません)</small>
            </div>
            <div class="item-body">
              <el-input class="input-7-digit"
                placeholder="1001000"
                title="郵便番号"
                type="tel"
                ref="postNumber"
                v-model.lazy="formatData.postNumber"
                v-on:blur="formatData.postNumber = cleanUp('postNumber', $event.target.value)"></el-input>
            </div>
            <div class="item-name">都道府県・市区町村・番地</div>
            <div class="item-body">
              <el-input type="textarea"
                autosize
                placeholder=""
                title="都道府県・市区町村"
                ref="address1"
                v-model="formatData.address1"
                v-on:blur="formatData.address1 = $formLib.zenToHanNumber($event.target.value)"></el-input>
            </div>
            <div class="item-name">マンション・建物名等</div>
            <div class="item-body">
              <el-input type="textarea"
                autosize
                placeholder=""
                title="マンション・建物名等"
                ref="address2"
                v-model="formatData.address2"
                v-on:blur="formatData.address2 = $formLib.zenToHanNumber($event.target.value)"></el-input>
            </div>
          </div>
          <div v-if="needs('addressFurigana')"
            class="edit-form-item">
            <div class="item-name">住所ふりがな</div>
            <div class="item-body">
              <el-input type="textarea"
                autosize
                placeholder=""
                title="住所ふりがな"
                ref="addressFurigana"
                v-model="formatData.addressFurigana"
                @blur="formatData.addressFurigana = $formLib.katakana2Hiragana(formatData.addressFurigana)"></el-input>
              <span style="color:red;">※「ふりがな」の入力は2行までとなります。３行になりますとフォーマットが崩れます。</span>
            </div>
          </div>
        </div>
        <div v-if="needs('contact')">
          <el-collapse v-model="formatData.useContact">
            <el-collapse-item name="1"
              title="上記以外に希望する連絡先がある場合">
              <p>下宿・留学をしていたり、長期で実家に戻る等、諸事情で上記以外に連絡を希望する場合のみ記入します。特にない場合は空欄のまま次に進んでください。</p>
              <p>&nbsp;</p>
              <div class="edit-form">
                <div class="edit-form-item">
                  <div class="item-name">
                    郵便番号
                    <small v-if="$deviceLib.isOnline">(ハイフン不要・住所が自動入力されます)</small>
                    <small v-else>(※オフラインのため住所の自動入力がご利用いただけません)</small>
                  </div>
                  <div class="item-body">
                    <el-input class="input-7-digit"
                      placeholder="1001000"
                      title="郵便番号"
                      type="tel"
                      v-model.lazy="formatData.contactPostNumber"
                      v-on:blur="formatData.contactPostNumber = cleanUp('postNumber', $event.target.value)"></el-input>
                  </div>
                  <div class="item-name">都道府県・市区町村・番地</div>
                  <div class="item-body">
                    <el-input type="textarea"
                      autosize
                      placeholder=""
                      title="都道府県・市区町村"
                      v-model="formatData.contactAddress1"
                      v-on:blur="formatData.contactAddress1 = $formLib.zenToHanNumber($event.target.value)"></el-input>
                  </div>
                  <div class="item-name">マンション・建物名等</div>
                  <div class="item-body">
                    <el-input type="textarea"
                      autosize
                      placeholder=""
                      title="マンション・建物名"
                      v-model="formatData.contactAddress2"
                      v-on:blur="formatData.contactAddress2 = $formLib.zenToHanNumber($event.target.value)"></el-input>
                  </div>
                </div>
                <div class="edit-form-item">
                  <div class="item-name">住所ふりがな</div>
                  <div class="item-body">
                    <el-input type="textarea"
                      autosize
                      placeholder=""
                      title="住所ふりがな"
                      v-model="formatData.contactAddressFurigana"
                      @blur="formatData.contactAddressFurigana = $formLib.katakana2Hiragana(formatData.contactAddressFurigana)"></el-input>
                    <span style="color:red;">※「ふりがな」の入力は2行までとなります。3行になりますとフォーマットが崩れます。</span>
                  </div>
                </div>
                <div class="edit-form-item">
                  <div class="item-name">方書<small>（履歴書に記入した苗字と、住所の表札の苗字が異なる場合のみ記入）</small></div>
                  <div class="item-body">
                    <el-input placeholder=""
                      title="方書き"
                      v-model="formatData.contactCareOf"></el-input>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
  <div class="card"
    v-show="currentCardId == 'contacts'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>連絡先を入力</h2>
        <p>連絡がつきやすい番号・メールアドレスを記入しましょう</p>
      </div>
      <div class="card-content">
        <div class="edit-form">
          <div v-if="needs('tel')"
            class="edit-form-item">
            <div class="item-name">電話番号</div>
            <div class="item-body">
              <el-input type="tel"
                class="input-4-digit"
                placeholder="090"
                title="電話番号"
                ref="tel1"
                v-model="formatData.tel1"
                v-on:blur="formatData.tel1 = $formLib.zenToHanNumber($event.target.value)"></el-input>
              -
              <el-input type="tel"
                class="input-4-digit"
                placeholder="1234"
                title="電話番号"
                ref="tel2"
                v-model="formatData.tel2"
                v-on:blur="formatData.tel2 = $formLib.zenToHanNumber($event.target.value)"></el-input>
              -
              <el-input type="tel"
                class="input-4-digit"
                placeholder="5678"
                title="電話番号"
                ref="tel3"
                v-model="formatData.tel3"
                v-on:blur="formatData.tel3 = $formLib.zenToHanNumber($event.target.value)"></el-input>
            </div>
          </div>

          <div v-if="needs('email')"
            class="edit-form-item">
            <div class="item-name">Email</div>
            <div class="item-body">
              <el-input class="input-md"
                placeholder=""
                title="メールアドレス"
                ref="email"
                v-model="formatData.email"
                type="email"></el-input>
              <div v-if="$firebase.isAuthenticated && $firebase.user.email !== formatData.email">
                <el-button @click="setAccountEmail"
                  type="text">「{{ $firebase.user.email }}」を入力する</el-button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="needs('contact')">
          <el-collapse v-model="formatData.useContact">
            <el-collapse-item name="1"
              title="上記以外に希望する連絡先がある場合">
              <p>長期で連絡がとれない期間がある等、諸事情で上記以外に連絡を希望する場合のみ記入します。特にない場合は空欄のまま次に進んでください。</p>
              <p>&nbsp;</p>
              <div class="edit-form"
                v-if="needs('contactTel')">
                <div class="edit-form-item">
                  <div class="item-name">電話番号</div>
                  <div class="item-body">
                    <el-input ref="tel1"
                      v-model="formatData.contactTel1"
                      type="tel"
                      class="input-4-digit"
                      placeholder="090"
                      title="電話番号"
                      v-on:blur="formatData.contactTel1 = $formLib.zenToHanNumber($event.target.value)"></el-input>
                    -
                    <el-input ref="tel2"
                      v-model="formatData.contactTel2"
                      type="tel"
                      class="input-4-digit"
                      placeholder="1234"
                      title="電話番号"
                      v-on:blur="formatData.contactTel2 = $formLib.zenToHanNumber($event.target.value)"></el-input>
                    -
                    <el-input ref="tel3"
                      v-model="formatData.contactTel3"
                      type="tel"
                      class="input-4-digit"
                      placeholder="5678"
                      title="電話番号"
                      v-on:blur="formatData.contactTel3 = $formLib.zenToHanNumber($event.target.value)"></el-input>
                  </div>
                </div>

                <div class="edit-form-item"
                  v-if="needs('contactEmail')">
                  <div class="item-name">Email</div>
                  <div class="item-body">
                    <el-input class="input-md"
                      placeholder=""
                      title="メールアドレス"
                      v-model="formatData.contactEmail"
                      type="email"></el-input>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
  <div class="card"
    v-show="currentCardId == 'id-photo'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>証明写真をアップロード</h2>
        <p>写真を一緒に印刷する場合、選んでください。</p>
      </div>
      <div class="card-content">
        <div v-if="needs('photo')"
          class="edit-form-item">
          <div class="rirekisho-photo-upload">
            <div class="rirekisho-photo-upload-image"
              v-if="formatData.idPhotoSrc"><img :src="formatData.idPhotoSrc"></div>
            <div class="photo-upload-action"
              v-if="!formatData.idPhotoSrc">
              <upload-photo v-on:upload-photo-complete="updatePhoto"></upload-photo>
            </div>
            <div class="button-photo-delete">
              <el-button v-if="formatData.idPhotoSrc"
                @click="deletePhoto()">削除</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-content">
        <el-collapse v-model="idPhotoActiveCollapses">
          <el-collapse-item title="使用する写真について"
            name="1">
            <ul class="collapse-list">
              <li>撮影から3カ月以内のものを使います</li>
              <li>本人とわかる、単身胸から上の画像を使用します</li>
              <li>縦36mm～40mm / 横24mm～30mmのサイズで撮影またはトリミングします</li>
              <li>写真の背景はブルー（水色）または白を選びましょう</li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="証明写真機で撮った写真を使うには"
            name="2">
            <p>証明写真機や写真館の「WEBデータ加工」「スマホデータ転送サービス」で証明写真の画像データを用意すると、上記の「写真をアップロード」ボタンから簡単に写真を貼り付けることができます。焼き増しの必要がなく、WEB上からのエントリーにも対応できます。</p>
            <ul class="collapse-list">
              <li><a href="http://fujifilm.jp/personal/print/photo/photo_box/">FUJIFILM 証明写真ボックス</a></li>
              <li><a href="http://www.dnpphoto.jp/products/kirei/with/">DNPフォトイメージングジャパン 証明写真機Ki-Re-i</a></li>
              <li><a href="http://www.kitamura-print.com/photo_id/">カメラのキタムラ 証明写真</a></li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="履歴書印刷後に写真を貼る場合"
            name="3">
            <p>履歴書を印刷した後に証明写真を貼る場合はこの過程はスキップし、次の「学歴を入力する」に進みます。<br> 写真を後から貼る場合は、万が一剥がれてしまっても誰であるかわかるように、裏面に名前と撮影日を書いておきましょう
            </p>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
  <div class="card"
    v-show="currentCardId == 'letterprofile'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>プロフィールを入力</h2>
        <p>氏名や連絡情報を入力してください</p>
      </div>
      <div class="card-content">
        <div class="edit-form">
          <div v-if="needs('name')"
            class="edit-form-item">
            <div class="item-name">氏名</div>
            <div class="item-body flex">
              <el-input v-model="formatData.lastName"
                class="input-sm"
                placeholder=""
                title="姓"
                @keyup.native.enter="$formLib.nextInput($refs.firstName)"></el-input>
              <el-input v-model="formatData.firstName"
                  ref="firstName"
                class="input-sm"
                placeholder=""
                title="名"
                @keyup.native.enter="$formLib.nextInput($refs.lastNameFurigana)"></el-input>
            </div>
          </div>
          <div v-if="needs('address')"
            class="edit-form-item">
            <div class="item-name">
              郵便番号
              <small v-if="$deviceLib.isOnline">(ハイフン不要・住所が自動入力されます)</small>
              <small v-else>(※オフラインのため住所の自動入力がご利用いただけません)</small>
            </div>
            <div class="item-body">
              <el-input class="input-7-digit"
                placeholder="1001000"
                title="郵便番号"
                type="tel"
                ref="postNumber"
                v-model.lazy="formatData.postNumber"
                v-on:blur="formatData.postNumber = cleanUp('postNumber', $event.target.value)"></el-input>
            </div>
            <div class="item-name">都道府県・市区町村・番地</div>
            <div class="item-body">
              <el-input type="textarea"
                autosize
                placeholder=""
                title="都道府県・市区町村"
                ref="address1"
                v-model="formatData.address1"
                v-on:blur="formatData.address1 = $formLib.zenToHanNumber($event.target.value)"></el-input>
            </div>
            <div class="item-name">マンション・建物名等</div>
            <div class="item-body">
              <el-input type="textarea"
                autosize
                placeholder=""
                title="マンション・建物名等"
                ref="address2"
                v-model="formatData.address2"
                v-on:blur="formatData.address2 = $formLib.zenToHanNumber($event.target.value)"></el-input>
            </div>
          </div>
          <div v-if="needs('tel')"
            class="edit-form-item">
            <div class="item-name">電話番号</div>
            <div class="item-body">
              <el-input type="tel"
                class="input-4-digit"
                placeholder="090"
                title="電話番号"
                ref="tel1"
                v-model="formatData.tel1"
                v-on:blur="formatData.tel1 = $formLib.zenToHanNumber($event.target.value)"></el-input>
              -
              <el-input type="tel"
                class="input-4-digit"
                placeholder="1234"
                title="電話番号"
                ref="tel2"
                v-model="formatData.tel2"
                v-on:blur="formatData.tel2 = $formLib.zenToHanNumber($event.target.value)"></el-input>
              -
              <el-input type="tel"
                class="input-4-digit"
                placeholder="5678"
                title="電話番号"
                ref="tel3"
                v-model="formatData.tel3"
                v-on:blur="formatData.tel3 = $formLib.zenToHanNumber($event.target.value)"></el-input>
            </div>
          </div>
          <div v-if="needs('email')"
            class="edit-form-item">
            <div class="item-name">連絡先（Email）</div>
            <div class="item-body">
              <el-input class="input-md"
                placeholder=""
                title="メールアドレス"
                ref="email"
                v-model="formatData.email"
                type="email"></el-input>
              <div v-if="$firebase.isAuthenticated && $firebase.user.email !== formatData.email">
                <el-button @click="setAccountEmail"
                  type="text">「{{ $firebase.user.email }}」を入力する</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import UploadPhoto from './UploadPhoto'
import LocalDataMixin from '@/mixins/local-data-mixin'

export default {
  name: 'basicInfo',
  mixins: [LocalDataMixin],
  components: {
    'upload-photo': UploadPhoto
  },
  props: {
    requiredBasicFields: {
      type: Array
    },
    currentCardId: {
      type: String
    }
  },
  data: function () {
    return {
      saveName: 'basicData',
      // format系と区別するため
      saveKeyPrefix: '',
      dataChangedEmitKey: 'basic-data-changed',
      formatData: {
        lastName: '',
        firstName: '',
        lastNameFurigana: '',
        firstNameFurigana: '',
        birthYear: '',
        birthMonth: '',
        birthDay: '',
        age: '',
        sex: '',
        postNumber: '',
        address1: '',
        address2: '',
        addressFurigana: '',
        tel1: '',
        tel2: '',
        tel3: '',
        email: '',
        idPhotoSrc: '',
        useContact: '',
        contactPostNumber: '',
        contactAddress1: '',
        contactAddress2: '',
        contactAddressFurigana: '',
        contactCareOf: '',
        contactTel1: '',
        contactTel2: '',
        contactTel3: '',
        contactMobile: '',
        contactFax: '',
        contactEmail: '',
        updateDate: ''
      },
      dialogVisible: false,
      savingNotify: {},
      idPhotoActiveCollapses: ['1']
    }
  },
  computed: {
    calcLastDay: function () {
      if (!this.formatData.birthYear || !this.formatData.birthMonth) {
        return 31
      }
      let ym
      try {
        ym = new Date(this.formatData.birthYear, this.formatData.birthMonth, 0)
      } catch (e) {
        console.error(e)
        return 31
      }
      if (ym) {
        return ym.getDate()
      }
    }
  },
  methods: {
    needs: function (name) {
      if (this.requiredBasicFields[0] === 'all') {
        return true
      }
      if (this.requiredBasicFields.indexOf(name) > -1) {
        return true
      } else {
        return false
      }
    },
    updatePhoto: function (data) {
      this.formatData.idPhotoSrc = data
    },
    deletePhoto: function () {
      this.formatData.idPhotoSrc = ''
    },
    cleanUp: function (name, value) {
      if (name === 'postNumber') {
        value = value.replace('-', '')
        value = this.$formLib.zenToHanNumber(value)
        return String(value)
      }
    },
    setAddressFromZip: function (postNumber) {
      const app = this
      const callback = function (data) {
        app.formatData.address1 = data.kanji
        app.formatData.addressFurigana = data.kana
      }
      this.$formLib.addressFromZip(postNumber, callback)
    },
    setContactAddressFromZip: function (postNumber) {
      const app = this
      const callback = function (data) {
        app.formatData.contactAddress1 = data.kanji
        app.formatData.contactAddressFurigana = data.kana
      }
      this.$formLib.addressFromZip(postNumber, callback)
    },
    setBirthDate: function () {
      if (this.formatData.birthYear && this.formatData.birthMonth && this.formatData.birthDay) {
        this.birthDate = new Date(this.formatData.birthYear, this.formatData.birthMonth, this.formatData.birthDay)
      }
    },
    setAccountEmail: function () {
      if (this.$firebase.user.email) {
        this.formatData.email = this.$firebase.user.email
      }
    },
    updateBirthYear: function (year) {
      this.calAge()
      this.formatData.birthYear = year
    },
    updateBirthMonth: function (month) {
      this.calAge()
      this.formatData.birthMonth = month
    },
    updateBirthDay: function (day) {
      this.calAge()
      this.formatData.birthDay = day
    },
    updateAge: function (age) {
      this.formatData.age = age
    },
    calAge: function () {
      if (!this.formatData.birthYear || !this.formatData.birthMonth || !this.formatData.birthDay) {
        return ''
      }
      const birthDate = new Date(this.formatData.birthYear, this.formatData.birthMonth - 1, this.formatData.birthDay)
      const createDate = new Date()
      const diff = new Date(createDate.getTime() - birthDate.getTime())
      const result = Math.abs(diff.getUTCFullYear() - 1970)
      if (isNaN(result)) {
        return ' '
      }
      this.formatData.age = result
    }
  },
  watch: {
    'formatData.postNumber': function (newValue, oldValue) {
      // skip first load
      if (!oldValue) {
        return
      }
      const postNumber = this.cleanUp('postNumber', String(newValue))
      if (String(postNumber).length === 7) {
        this.setAddressFromZip(postNumber, 'address1', 'addressFurigana')
      }
    },
    'formatData.contactPostNumber': function (newValue, oldValue) {
      // skip first load
      if (!oldValue) {
        return
      }
      const postNumber = this.cleanUp('postNumber', String(newValue))
      if (String(postNumber).length === 7) {
        this.setContactAddressFromZip(postNumber, 'contactAddress1', 'contactAddressFurigana')
      }
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('birth-year-changed', this.updateBirthYear)
    this.$eventHub.$on('birth-month-changed', this.updateBirthMonth)
    this.$eventHub.$on('birth-day-changed', this.updateBirthDay)
    this.$eventHub.$on('age-changed', this.updateAge)
  },
  destroyed: function () {
    this.$eventHub.$off('birth-year-changed', this.updateBirthYear)
    this.$eventHub.$off('birth-month-changed', this.updateBirthMonth)
    this.$eventHub.$off('birth-day-changed', this.updateBirthDay)
    this.$eventHub.$off('age-changed', this.updateAge)
  }
}
</script>
